module.exports = __webpack_public_path__ + "img/iceberg.99b673f1.svg";